import React from "react";
import { FormikInput } from "components/common";
const _validateIndexPrefix = (value) => {
  let error;
  if ((value == null ? void 0 : value.length) === 0) {
    error = "Invalid index prefix: cannot be empty";
  } else if ((value == null ? void 0 : value.indexOf("_")) === 0 || (value == null ? void 0 : value.indexOf("-")) === 0 || (value == null ? void 0 : value.indexOf("+")) === 0) {
    error = "Invalid index prefix: must start with a letter or number";
  } else if ((value == null ? void 0 : value.toLocaleLowerCase()) !== value) {
    error = "Invalid index prefix: must be lower case";
  } else if (!(value == null ? void 0 : value.match(/^[a-z0-9][a-z0-9_\-+]*$/))) {
    error = "Invalid index prefix: must only contain letters, numbers, '_', '-' and '+'";
  }
  return error;
};
const IndexSetReadOnlyConfiguration = ({
  hiddenFields,
  immutableFields,
  ignoreFieldRestrictions,
  onPrefixChange
}) => {
  const indexPrefixHelp = /* @__PURE__ */ React.createElement("span", null, "A ", /* @__PURE__ */ React.createElement("strong", null, "unique"), " prefix used for indices belonging to this index set. The prefix must start with a letter or number, and can only contain letters, numbers, '_', '-' and '+'.");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    FormikInput,
    {
      type: "text",
      id: "index-prefix",
      label: "Index prefix",
      name: "index_prefix",
      help: indexPrefixHelp,
      validate: _validateIndexPrefix,
      onChange: onPrefixChange,
      required: true
    }
  ), (!hiddenFields.includes("index_analyzer") || ignoreFieldRestrictions) && /* @__PURE__ */ React.createElement(
    FormikInput,
    {
      type: "text",
      id: "index-analyzer",
      label: "Analyzer",
      name: "index_analyzer",
      help: "Analyzer for this index set.",
      required: true,
      disabled: immutableFields.includes("index_analyzer") && !ignoreFieldRestrictions
    }
  ));
};
export default IndexSetReadOnlyConfiguration;
